/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Billing_Feature_Cost_NInputs */

const cs_billing_feature_cost_n = /** @type {(inputs: Billing_Feature_Cost_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} kreditů`)
};

const en_billing_feature_cost_n = /** @type {(inputs: Billing_Feature_Cost_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} credits`)
};

/**
* | output |
* | --- |
* | "{n} credits" |
*
* @param {Billing_Feature_Cost_NInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_feature_cost_n = /** @type {((inputs: Billing_Feature_Cost_NInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Feature_Cost_NInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_feature_cost_n(inputs)
	return cs_billing_feature_cost_n(inputs)
});